import { Apollo_gql, GraphQueryPayload } from '@camelot/server';

import { cmsProps } from './dto/cms';
import { saleProps } from './dto/sale';

export function GET_CMS_CONTENT(type: string, locale: string, uid: string): GraphQueryPayload {
  return {
    query: Apollo_gql`
      query CmsContents($type: String!, $locale: I18NLocaleCode!, $uid: String!, $pagination: PaginationArg) {
        contentContents(locale: $locale, filters: { Type: { eq: $type }, partner: { UID: { eq: $uid } } }, pagination: $pagination ) {
          ${cmsProps.get('Title')}
          ${cmsProps.get('Description')}
          ${cmsProps.get('Type')}
          ${cmsProps.get('createdAt')}
          ${cmsProps.get('updatedAt')}
          ${cmsProps.get('publishedAt')}
        }
      }
    `,
    variables: {
      locale: locale,
      pagination: { page: 1, pageSize: 1000 },
      type: type,
      uid: uid,
    },
  };
}

export function GET_SALE_CONTENT(uid: string, locale: string): GraphQueryPayload {
  return {
    query: Apollo_gql`
      query Sale($locale: I18NLocaleCode!, $uid: String!, $pagination: PaginationArg) {
        contentSales(locale: $locale, filters: { partner: { UID: { eq: $uid } } }, pagination: $pagination ) {
          ${saleProps.get('Content')}
        }
      }
    `,
    variables: {
      locale: locale,
      pagination: { page: 1, pageSize: 1000 },
      uid: uid,
    },
  };
}
